import { InvoiceTemplateConceptResponse } from './invoice-template-concept-response.model';

export class InvoiceTemplate {
  id: string;
  name: string;
  isActive: boolean;
  ceco: string;
  zoneId: number;
  concepts: InvoiceTemplateConceptResponse[];
}
